import InputField from '../../../../../component/form/FormInput';
import { useEffect, useState } from 'react';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import { createCustomer } from '../../../../../services/customers';
import { toast } from 'react-toastify';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import { mergeUniqueById } from '../../../../../utils/controller';

const AddCustomerModel = ({
	setIsAddCustomerModalOpen,
	isAddCustomerModalOpen,
	setCustomerList,
	setInvoice,
}) => {
	const [customerDisplayNameList, setCustomerDisplayNameList] = useState([]);
	const [errors, setError] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [customer, setCustomer] = useState({
		customer_type: 0,
		customer_name: '',
		company_name: '',
		customer_display_name: '',
		customer_email: '',
		customer_phone_mobile: '',
		customer_phone_work: '',
		customer_credit_days: 0,
	});
	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};
	const handleCustomerBasicDetails = (type, value) => {
		setCustomer((prev) => ({
			...prev,

			[type]: type === 'customer_type' ? Number(value) : value,
		}));
		var customerError = { ...errors };
		if (type === 'customer_phone_work' || type === 'customer_phone_mobile') {
			if (value) {
				if (value.length > 10 || value.length < 10) {
					customerError[type] =
						`Please enter valid ${type === 'customer_phone_work' ? 'Phone Work' : 'Phone Mobile'} number`;
				} else {
					delete customerError[type];
				}
			} else {
				delete customerError[type];
			}
		}
		if (type === 'customer_email') {
			if (value) {
				if (validateEmail(value)) {
					delete customerError[type];
				} else {
					customerError[type] = 'Please enter valid email address';
				}
			} else {
				delete customerError[type];
			}
		}
		setError(customerError);
	};
	const handleCustomerName = (type, value) => {
		if (type === 'customer_name' && customer.customer_type === 0) {
			setCustomer((prev) => ({
				...prev,

				[type]: value,
				customer_display_name: value,
			}));
		} else {
			setCustomer((prev) => ({
				...prev,

				[type]: value,
			}));
		}
		var errorData = { ...errors };
		if (type === 'customer_name' && (value === '' || value === undefined)) {
			errorData['customer_name'] = 'Please enter customer name in the field';
		} else {
			delete errorData['customer_name'];
			delete errorData['customer_display_name'];
		}
		if (type === 'customer_display_name' && (value === '' || value === undefined)) {
			errorData['customer_display_name'] = 'Please enter customer display name in the field';
		} else {
			delete errorData['customer_display_name'];
		}
		setError(errorData);
	};

	const checkValidation = () => {
		var error = { ...errors };

		if (
			!customer.customer_name ||
			customer.customer_name === undefined ||
			customer.customer_name === ''
		) {
			error.customer_name = 'Please enter customer name in the field';
		} else {
			delete error.customer_name;
		}

		if (customer.customer_type === 1) {
			if (
				!customer.company_name ||
				customer.company_name === undefined ||
				customer.company_name === ''
			) {
				error.company_name = 'Please enter company name in the field';
			} else {
				delete error.company_name;
			}
		} else {
			delete error.company_name;
		}
		if (
			!customer.customer_display_name ||
			customer.customer_display_name === undefined ||
			customer.customer_display_name === ''
		) {
			error.customer_display_name = 'Please enter customer display name in the field';
		} else {
			delete error.customer_display_name;
		}

		if (Object.keys(error).length > 0) {
			setError(error);
			return true;
		} else {
			return false;
		}
	};

	async function handleAddCustomer() {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			setLoading(true);
			const formData = new FormData();
			const customerObj = {
				type: customer.customer_type,
				status: 1,
				name: customer.customer_name,
				display_name: customer.customer_display_name,
				email: customer.customer_email,
				phone: customer.customer_phone_work,
				mobile: customer.customer_phone_mobile,
				credit_days: customer.customer_credit_days,
			};
			for (const key in customerObj) {
				formData.append(key, customerObj[key]);
			}

			if (customer.company_name && customer.customer_type === 1) {
				var business_info = {
					company_name: customer.company_name,
				};
				formData.append('customer_business', JSON.stringify(business_info));
			}

			try {
				const res = await createCustomer(formData);
				if (res?.success) {
					const newCustomer = {
						key: res?.data?.customer?.id,
						value: customer.customer_name,
					};
					setCustomerList((prev) => mergeUniqueById([newCustomer], prev || []));
					setInvoice((prev) => ({
						...prev,
						customer_id: res?.data?.customer?.id,
					}));
					toast.success(res?.message);
					setIsAddCustomerModalOpen(false);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	}
	const handleDisplayCustomerNameList = () => {
		const data = [
			{
				key: customer.customer_name,
				value: customer.customer_name,
			},
			{
				key: customer.company_name,
				value: customer.company_name,
			},
		];
		setCustomerDisplayNameList(data);
	};

	useEffect(() => {
		handleDisplayCustomerNameList();
	}, [customer.customer_name, customer.company_name]);

	return (
		<Modal
			className={'addCustomerModal'}
			title="Add Customer"
			isOpen={isAddCustomerModalOpen}
			onClose={() => {
				setIsAddCustomerModalOpen(false);
			}}
			cancelButton={() => {
				setIsAddCustomerModalOpen(false);
			}}
		>
			<div>
				<div
					className="row"
					style={{ margin: '15px 0px' }}
				>
					<div
						className="col"
						style={{ paddingBottom: '9px', paddingLeft: '0px', paddingRight: '0px' }}
					>
						<label
							style={{
								fontWeight: 'bold',
								marginBottom: '1.3rem',
								display: 'block',
							}}
						>
							Customers Type
						</label>

						<div style={{ display: 'flex', gap: '40px' }}>
							<label
								style={{
									marginRight: '1.5rem',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<input
									type="radio"
									name="customerType"
									value={0}
									checked={customer.customer_type === 0}
									onChange={(e) => {
										const value = e.target.value;
										handleCustomerBasicDetails('customer_type', value);
									}}
									style={{
										cursor: 'pointer',
										marginRight: '0.75rem',
										width: '20px',
										height: '20px',
										borderRadius: '10px',
									}}
								/>
								Individual
							</label>
							<label
								style={{
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<input
									type="radio"
									name="customerType"
									value={1}
									checked={customer.customer_type === 1}
									onChange={(e) => {
										const value = e.target.value;
										handleCustomerBasicDetails('customer_type', value);
									}}
									style={{
										cursor: 'pointer',
										marginRight: '0.75rem',
										width: '20px',
										height: '20px',
										borderRadius: '10px',
									}}
								/>
								Business
							</label>
						</div>
					</div>

					{customer.customer_type === 1 && (
						<div className="col">
							<InputField
								label="Company Name"
								placeholder="Company Name"
								type="text"
								value={customer.company_name}
								onChange={(value) => handleCustomerBasicDetails('company_name', value)}
								required={true}
								error={errors.company_name}
							/>
						</div>
					)}
				</div>
				<div
					className="row"
					style={{ margin: '15px 0px' }}
				>
					<div className="col">
						<div style={{ position: 'relative' }}>
							<InputField
								label="Customer Name"
								placeholder="Customer Name"
								type="text"
								autoFocus={true}
								value={customer.customer_name}
								onChange={(value) => {
									handleCustomerName('customer_name', value);
								}}
								required={true}
								error={errors.customer_name}
							/>
						</div>
					</div>
					<div className="col">
						{customer.customer_type === 1 ? (
							<InputSelect
								options={customerDisplayNameList || []}
								placeholder="Select Customer Display Name"
								label="Customer Display Name"
								onChange={(value) => {
									if (value === null || value === '') {
										handleCustomerName('customer_display_name', value);
									}
								}}
								onSelect={(value) => handleCustomerName('customer_display_name', value.key)}
								value={customer.customer_display_name}
								required={true}
								error={errors?.customer_display_name}
							/>
						) : (
							<InputField
								label="Customer Display Name"
								placeholder="Customer Display Name"
								type="text"
								value={customer.customer_display_name}
								onChange={(value) => handleCustomerName('customer_display_name', value)}
								required={true}
								error={errors.customer_display_name}
							/>
						)}
					</div>
				</div>
				<div
					className="row"
					style={{ margin: '15px 0px' }}
				>
					<div className="col">
						<InputField
							label="Customer Email"
							placeholder="Customer Email"
							value={customer.customer_email}
							onChange={(value) => handleCustomerBasicDetails('customer_email', value)}
							type="text"
							error={errors.customer_email}
						/>
					</div>
					<div className={customer.customer_type === 0 ? 'col-3' : 'col-6'}>
						<InputField
							label="Phone(Mobile)"
							placeholder="Mobile Number"
							type="text"
							maxLength={10}
							value={customer.customer_phone_mobile}
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9]/g, '');
								handleCustomerBasicDetails('customer_phone_mobile', value);
							}}
							style={{ textAlign: 'left' }}
							error={errors.customer_phone_mobile}
						/>
					</div>
					{customer.customer_type === 0 && (
						<div className="col-3">
							<InputField
								label="Credit Days"
								placeholder="0"
								value={customer.customer_credit_days}
								onChange={(value) => handleCustomerBasicDetails('customer_credit_days', value)}
								type="number"
								style={{ textAlign: 'right' }}
							/>
						</div>
					)}
				</div>
				{customer.customer_type === 1 && (
					<div
						className="row"
						style={{ margin: '15px 0px' }}
					>
						<div className="col-6">
							<InputField
								label="Phone(Work)"
								placeholder="Phone(Work)"
								maxLength={10}
								value={customer.customer_phone_work}
								onChange={(valueData) => {
									var value = valueData?.replace(/[^0-9]/g, '');
									handleCustomerBasicDetails('customer_phone_work', value);
								}}
								type="text"
								style={{ textAlign: 'left' }}
								error={errors.customer_phone_work}
							/>
						</div>

						<div className="col-6">
							<InputField
								label="Credit Days"
								placeholder="0"
								value={customer.customer_credit_days}
								onChange={(value) => handleCustomerBasicDetails('customer_credit_days', value)}
								type="number"
								style={{ textAlign: 'right' }}
							/>
						</div>
					</div>
				)}
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'end',
						gap: 12,
						marginTop: '10px',
					}}
				>
					<Button
						type="button"
						className="mt-0 btn-primary add-pro"
						button="Save"
						loader={isLoading}
						onClick={() => handleAddCustomer()}
					/>
					<Button
						type="button"
						className="mt-0 btn-gray add-pro"
						button="Cancel"
						onClick={() => setIsAddCustomerModalOpen(false)}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default AddCustomerModel;
